import React from "react";
import FormSection from "../components/contact/FormSection";
import AnythingElseSection from "../components/contact/AnythingElseSection";

const Contact = () => {
  return (
    <div>
      <FormSection />
      <AnythingElseSection />
    </div>
  );
};

export default Contact;
